module.exports = __webpack_public_path__ + "assets/img/virtue_icon0.f2e958fa.svg";